import apiClient from "@/services";

const getRecentProducts = async () => {
  try {
    const { status, data } = await apiClient.get("/getRecentProducts");

    if (status === 200) {
      return data;
    } else {
      throw new Error(`Unexpected response status: ${status}`);
    }
  } catch (error) {
    console.error("Error fetching recent products:", error.message || error);
    return [];
  }
};

export default getRecentProducts;
